<template>
    <a
        :href="checkoutUrl"
        @click.prevent="openCheckout"
        v-observe-visibility="visibilityChanged"
        class="checkout_popup_btn"
        :class="{ 'no-anim': popup.isOpen }"
        ref="btn">
        <slot></slot>
    </a>
</template>

<script>
import { mapState } from 'vuex';
import { iosview } from '../../../iosview';
import { bannerAnim, topBarAnim } from '../../../animations';
import { preventBrowserHistorySwipeGestures } from '../../../iosview';

export default {
    data: function () {
        return {
            salesButtonSeenFirstTime: false,
        };
    },
    props: {
        step: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        ...mapState(['contact', 'customOrderFields', 'popup']),
        checkoutUrl() {
            let url =
                window.location.origin +
                window.location.pathname +
                '?' +
                window.location.search.substr(1) +
                '&mode=reader&checkout-opened';
            return url;
        },
    },
    methods: {
        openCheckout(event) {
            if (this.isIosView) {
                this.$store.commit('setProcessingCheckout', true);
                iosview.salesButtonClicked();
                return;
            }

            this.$store.commit('openCheckout', {
                step: this.step,
            });

            this.tracker.firePixelEvent('checkout_buy_button_is_clicked');

            window.ipse.dispatch({
                action: 'start_checkout_clicked',
                data_event: {
                    section_name:
                        event.srcElement.closest('[data-track-name]')?.getAttribute('data-track-name') ?? 'unknown',
                },
            });
        },

        visibilityChanged(isVisible) {
            if (isVisible) {
                this.tracker.firePixelEvent('first_buy_buttons_are_seen');
                this.salesButtonSeenFirstTime = true;
                this.$store.commit('salesButtonVisible', true);
            } else {
                if (this.salesButtonSeenFirstTime) {
                    this.$store.commit('salesButtonSeen');
                    /*
                     * Call a helper function from question-form.js
                     * to handle question button appearence when floating sales button is visible
                     */
                    floatingSalesButtonVisible();
                }
                this.$store.commit('salesButtonVisible', false);
            }
        },

        observeButton() {
            const btn = this.$refs.btn.querySelector('.buy-button');
            const noBanner = !btn || (window.App.isIosView && !window.App.isIosPwa);

            if (noBanner) return;

            bannerAnim(btn);
        },
    },
    mounted() {
        this.observeButton();
        topBarAnim();

        if (!this.isIosView) return;
        preventBrowserHistorySwipeGestures();
    },
};
</script>
